module.exports = "<p>{{ message }}</p> <div class=form-field> <a class=\"button button-beta button-flat\" ng-click=close() href=/settings/plan translate>limit.upgrade</a> <button class=\"button-flat message-trigger\" ng-click=close() translate=message.button.dismiss> Dismiss </button> </div> ";


//////////////////
// WEBPACK FOOTER
// ./app/common/notifications/limit.html
// module id = 459
// module chunks = 0